import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, Eye, EyeOff } from 'lucide-react';
import { supabase } from '../lib/supabase';
import { useApp } from '../store/useApp';
import { Logo } from '../components/Logo';
import { LangSelector } from '../components/LangSelector';

function fuerza(p) {
  let n = 0;
  if (p.length >= 10) n++;
  if (p.length >= 14) n++;
  if (/[a-zA-Z]/.test(p) && /[0-9]/.test(p)) n++;
  if (/[^a-zA-Z0-9]/.test(p)) n++;
  return Math.min(n, 4);
}

export default function CambiarPassword() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const { revisarCambioPassword } = useApp();
  const [p1, setP1] = useState('');
  const [p2, setP2] = useState('');
  const [ver, setVer] = useState(false);
  const [msg, setMsg] = useState('');
  const [cargando, setCargando] = useState(false);

  const valida = p1.length >= 10 && /[a-zA-Z]/.test(p1) && /[0-9]/.test(p1);
  const f = fuerza(p1);
  const nivel = ['', t('cambiar.fuerza_debil'), t('cambiar.fuerza_media'), t('cambiar.fuerza_buena'), t('cambiar.fuerza_fuerte')][f];

  const guardar = async (e) => {
    e.preventDefault(); setMsg('');
    if (!valida) { setMsg(t('cambiar.error_requisitos')); return; }
    if (p1 !== p2) { setMsg(t('cambiar.error_no_coinciden')); return; }
    setCargando(true);
    const { error } = await supabase.auth.updateUser({ password: p1, data: { debe_cambiar_password: false } });
    if (error) { setMsg(error.message); setCargando(false); return; }
    await revisarCambioPassword(); // refresca el flag desde el servidor
    useApp.setState({ debeCambiarPassword: false });
    setCargando(false);
    nav('/', { replace: true });
  };

  return (
    <div className="center-page">
      <div className="card stack" style={{ width: 440, maxWidth: '100%' }} data-testid="cambiar-password-card">
        <div className="row" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <Logo endoso />
          <LangSelector />
        </div>
        <div className="banner aviso" data-testid="cambiar-aviso"><ShieldAlert size={16} /> {t('cambiar.aviso')}</div>
        <form className="stack" onSubmit={guardar}>
          <h1>{t('cambiar.titulo')}</h1>
          <div className="field">
            <label className="label">{t('cambiar.nueva')}</label>
            <div className="row" style={{ gap: 6 }}>
              <input type={ver ? 'text' : 'password'} value={p1} onChange={(e) => setP1(e.target.value)}
                autoFocus autoComplete="new-password" minLength={10} required data-testid="password-nueva" />
              <button type="button" className="btn ghost sm" onClick={() => setVer((v) => !v)} data-testid="ver-password-btn">
                {ver ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
            {p1 && (
              <div className="fuerza" data-testid="fuerza-indicador">
                <div className="fuerza-barra"><div className={`fuerza-relleno f${f}`} style={{ width: `${(f / 4) * 100}%` }} /></div>
                <span className="small muted" data-testid="fuerza-texto">{nivel}</span>
              </div>
            )}
          </div>
          <div className="field">
            <label className="label">{t('cambiar.repetir')}</label>
            <input type={ver ? 'text' : 'password'} value={p2} onChange={(e) => setP2(e.target.value)}
              autoComplete="new-password" minLength={10} required data-testid="password-repetir" />
          </div>
          <p className="muted small">{t('cambiar.requisitos')}</p>
          <button className="btn primary op" disabled={cargando || !valida || p1 !== p2} data-testid="guardar-password-btn">
            {cargando ? t('comun.guardando', 'Guardando…') : t('cambiar.guardar')}
          </button>
          {msg && <p className="small" style={{ color: 'var(--ocupada)' }} data-testid="cambiar-error">{msg}</p>}
        </form>
      </div>
    </div>
  );
}
